import type { OwnerRefreshTokenResponse } from "wagAPI";
import type { OwnerRefreshTokenParsedResponse } from "webApp";
export const getOwnerRefreshTokenResponseParser = ({
  token
}: OwnerRefreshTokenResponse) => ({
  ownerToken: token
} as OwnerRefreshTokenParsedResponse);
export default getOwnerRefreshTokenResponseParser;